// Section 9 and 10: Workshop. 12 build points, 10 wood and 6 stone; toolmakers 1.5x; +20 tool
// capacity; loom included (weavers need it, 1.5x). Limit 1. Constants: config.buildings.workshop.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import {
  buildingEffectHook,
  capacityHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function workshop(config: Config) {
  const c = config.buildings.workshop;

  return defineBuilding({
    id: 'workshop',
    label: 'Workshop',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: { tools: c.toolCapacity },
    limit: { kind: 'fixed', max: c.limit },
    modifierTargets: ['capacity', 'output', 'buildingEffect'],
    modifierKeys: { output: ['toolmaker', 'weaver'] },
    modifiers: combineModifiers(
      buildingEffectHook('workshop'),
      capacityHook('workshop', { tools: c.toolCapacity }),
      (ctx, target) => {
        if (target.kind !== 'output') return [];
        const e = Math.min(1, effective(ctx, 'workshop'));
        if (e <= 0) return [];
        if (target.jobId === 'toolmaker') {
          return [
            mod.mul(
              'building:workshop',
              1 + (config.jobs.toolmaker.workshopFactor - 1) * e,
              'workshop',
            ),
          ];
        }
        if (target.jobId === 'weaver')
          return [
            mod.mul('building:workshop', 1 + (config.jobs.weaver.loomFactor - 1) * e, 'loom'),
          ];
        return [];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
